export const ActionTypes = {
  LOADING: "SIGN_UP_LOADING",
  ERROR: "SIGN_UP_ERROR",
  SUCCESS: "SIGN_UP_SUCCESS",
};
